import Hashids from "hashids";
const hashids = new Hashids();

// mock json
import mockProducts from "../mock/testdata.json";

// later swap this file to call your API services
export async function loadRemoteProducts(routeId) {
  // decode your hashid string to code (same idea you already have)
  const code = hashids.decode(routeId).toString();

  // for now, just return mock data
  return {
    code,
    business: { name: "Remote Order" },
    products: Array.isArray(mockProducts) ? mockProducts : [],
  };
}